<template>
    <el-form :model="assetKind" :rules="assetKindRules" :label-position="'left'" ref="assetKindInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="name">
                        <el-input v-model="assetKind.name" placeholder="请输入分类名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">编码</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="code">
                        <el-input v-model="assetKind.code" placeholder="请输入分类编码"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">资产属性</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="assetKindId">
                        <el-select v-if="assetKind.level == 1 || assetKind.level == null" v-model="assetKind.assetNature" collapse-tags placeholder="请选择">
                            <el-option v-for="item in assetNatureList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                        <span v-else>{{assetNatureMap[assetKind.assetNature]}}</span>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import assetApi from '../../api/asset'

    export default {
        name: 'swb-asset-kind-save',
        desc: '',
        props: ["item"],
        data: function () {
            let checkName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(value.length > 30) {
                        callback(new Error("名称长度最多30个字符"))
                    } else {
                        callback();
                    }
                }
            };
            let checkCode = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                assetKind: {
                    assetNature: getEnumInfoWith("assetNature", "name", "NONE").value,
                },
                assetNatureList: getEnumList("assetNature"),
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetKindRules: {
                    name: [{validator: checkName, trigger: 'blur'}],
                    code: [{validator: checkCode, trigger: 'blur'}],
                    assetNature: [{validator: checkCode, trigger: 'blur'}]
                }
            }
        },
        created: function () {
            let self = this;
            //
            self.getInit();
        },
        methods: {
            getInit: function () {
                let self = this;
                let item = self.item;
                if(!Utils.isNoB(item.id)) {
                    let postData = {};
                    postData.id = item.id;
                    let theLoad = MsgBox.loading();
                    assetApi.getAssetKind(postData, function (result) {
                        theLoad.hide();
                        if(result.type === 'info') {
                            let assetKind = result.data;
                            //
                            self.assetKind = Utils.merge({}, assetKind);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    if(!Utils.isNoB(item) && !Utils.isNoB(item.parentId)) {
                        self.assetKind = item;
                    }
                }
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['assetKindInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = 'info';
                        result.data = self.assetKind;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/AssetKindSave.vue